// default list of IDs used in the slideout
/**
 * ID for the main title in the slideout. Passed to `Dialog`'s `aria-labelledby` prop in `ModalSlideout`.
 */
export const ariaTitleId = 'slideout-title';
/**
 * ID for the sub-title in the slideout. Passed to `Dialog`'s `aria-labelledby` prop in `ModalSlideout`.
 */
export const ariaSubTitleId = 'slideout-subTitle';
/**
 * ID for the main content in the slideout. It reads the whole content if set. Passed to `Dialog`'s `aria-describedby` prop in `ModalSlideout`.
 */
export const ariaContentDefaultId = 'slideout-content';
/**
 * ID for the additional component next to the main title. It reads the whole content if set. Passed to `Dialog`'s `aria-describedby` prop in `ModalSlideout`.
 */
export const ariaTitleAdditionalInfoId = 'slideout-additional-title-content';
